import { useCatalogFilterStore } from '@/stores/catalog-filter-store';
import { Box, Button, Chip } from '@mui/material';
import { Close } from '@mui/icons-material';

export function ActiveFilters() {
  const { filters, setManufacturer, setItemGroup, clearAll } =
    useCatalogFilterStore();

  const chips: { label: string; onDelete: () => void }[] = [];

  if (filters.manufacturerName) {
    chips.push({
      label: filters.manufacturerName,
      onDelete: () => setManufacturer(undefined, undefined),
    });
  }
  if (filters.itemGroupName) {
    chips.push({
      label: filters.itemGroupName,
      onDelete: () => setItemGroup(undefined, undefined),
    });
  }

  if (chips.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        flexWrap: 'wrap',
        mb: 1.5,
      }}
    >
      {chips.map((chip) => (
        <Chip
          key={chip.label}
          label={chip.label}
          size="small"
          onDelete={chip.onDelete}
          deleteIcon={<Close sx={{ fontSize: '14px !important' }} />}
          sx={{
            height: 26,
            fontSize: '0.75rem',
            backgroundColor: 'primary.main',
            color: 'white',
            '& .MuiChip-deleteIcon': {
              color: 'rgba(255,255,255,0.7)',
              '&:hover': { color: 'white' },
            },
          }}
        />
      ))}
      {chips.length > 1 && (
        <Button
          size="small"
          onClick={clearAll}
          sx={{
            fontSize: '0.7rem',
            textTransform: 'none',
            minWidth: 0,
            py: 0.25,
          }}
        >
          Alle entfernen
        </Button>
      )}
    </Box>
  );
}
